import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const ifsCatalogPlugin = createPlugin({
  id: 'ifs-catalog',
  routes: {
    root: rootRouteRef,
  },
});

export const IfsCatalogPage = ifsCatalogPlugin.provide(
  createRoutableExtension({
    name: 'IfsCatalogPage',
    component: () =>
      import('./components/CatalogPage/CatalogPage').then(m => m.CatalogPage),
    mountPoint: rootRouteRef,
  }),
);
